import React, { useState, useContext } from 'react'

import Modal from 'components/Modal'
import ModalContent from 'components/ModalContent'
import ModalTitle from 'components/ModalTitle'
import CurrencySearch from 'components/CurrencySearch'

const TokenProviderModal = ({
  onDismiss,
  setSearchPoolType,
  searchPoolType,
}) => {
  const handleCloseSelector = () => {
    onDismiss()
  }

  return (
    <Modal>
      <ModalTitle text="Select Token" />
      <ModalContent>
        <CurrencySearch
          selectedCurrency={searchPoolType}
          onCurrencySelect={setSearchPoolType}
          handleBlack={handleCloseSelector}
        />
      </ModalContent>
    </Modal>
  )
}

export default TokenProviderModal
